import React from "react";
import { useInView } from "react-intersection-observer";
import { NavLink } from "react-router-dom";
import { GoArrowUpRight } from "react-icons/go";
import { ReactSVG } from "react-svg";

const NoticeCard = ({ cd }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <NavLink
      to={`${cd.link}`}
      ref={ref}
      className={`bg-[#F6F6F6] hover:bg-[#DEE9E4] lg:w-[23rem] md:w-[21rem] w-[19rem]  group  flex flex-col xl:gap-10 lg:gap-6 md:gap-8 gap-4 xl:px-6 px-4  xl:py-8 py-4 rounded-xl ${
        inView ? `lg:animate-slideUp ${cd.class}` : "opacity-0"
      }`}
    >
      <div className="flex justify-between items-center  relative">
        <div className="xl:p-3 p-2 rounded-lg shadow-xl bg-white text-[#00643b] group-hover:text-white group-hover:bg-[#00643b]">
          {/* <img src={cd.icon} className="" alt="" /> */}
          <ReactSVG src={cd.icon} className={`xl:w-8 lg:w-6 w-8 mx-auto`} />
        </div>

        <GoArrowUpRight className="xl:size-8 lg:size-6 size-8 text-[#00643b] transition-opacity duration-500 " />
      </div>

      <div className="flex flex-col gap-1">
        <span className="xl:text-[1.5rem] lg:text-[1.3rem] md:text-[1.5rem] text-[1.3rem] font-semibold">
          {cd.name}
        </span>
        <span className="text-[#4E4E4E] xl:text-[1.1rem] lg:text-[.95rem] md:text-[1rem] text-[.9rem]">
          {cd.text}
        </span>
      </div>
    </NavLink>
  );
};

export default NoticeCard;
